<template>
  <div class="veo-values-item">
    <lazy-image
      v-if="getIsTabletOrMobile"
      :lazy_src="image_src"
      :src="image_lazy_src"
      class="veo-values-item__bg"
      cover_img/>
    <div class="position-relative veo-values-item_block">
      <div class="veo-values-item__img">
        <img :src="icon_src" alt="Veo Values"/>
      </div>
      <div class="veo-values-item__title">
        {{title}}
      </div>
      <div class="veo-values-item__text">
        {{text}}
      </div>
    </div>
  </div>
</template>

<script>

import LazyImage from "../../small_parts/LazyImage.vue";
import {mapGetters} from "vuex";

export default {
  name: "VeoValuesItem",
  components: {LazyImage},
  props: {
    icon_src: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    image_src: {
      type: String,
      default: '',
    },
    image_lazy_src: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters([
      'getIsTabletOrMobile'
    ]),
  }
}
</script>
